import List from "./List";
import Creator from "./Creator";

const UIS = { Creator, List };

export default UIS;
